export type WorkflowHistoryPoint = { timestamp: string; byStatus: Record<string, number> };

export type WorkflowHistoryPercentagePoint = {
  timestamp: number;
  total: number;
  rawByStatus: Record<string, number>;
} & Record<string, number | Record<string, number>>;

const normaliseStatus = (status: string) => status.trim().toLowerCase();

/** A history point is a status snapshot. Percentages therefore describe that
 * snapshot's composition, rather than arrivals or completions within a bucket. */
export function workflowHistoryPercentageData(points: WorkflowHistoryPoint[]): WorkflowHistoryPercentagePoint[] {
  const statuses = [...new Set(points.flatMap((point) => Object.keys(point.byStatus).map(normaliseStatus)))];

  return points.map((point) => {
    const byStatus = Object.fromEntries(statuses.map((status) => [status, Object.entries(point.byStatus).filter(([key]) => normaliseStatus(key) === status).reduce((sum, [, count]) => sum + count, 0)]));
    const total = Object.values(byStatus).reduce((sum, count) => sum + count, 0);
    const percentages = Object.fromEntries(
      Object.entries(byStatus).map(([status, count]) => [status, total > 0 ? count / total * 100 : 0]),
    );

    return { timestamp: new Date(point.timestamp).getTime(), total, rawByStatus: byStatus, ...percentages };
  });
}
